import { render } from "./notificationMessage.vue?vue&type=template&id=4b13cc00&scoped=true"
import script from "./notificationMessage.vue?vue&type=script&lang=js"
export * from "./notificationMessage.vue?vue&type=script&lang=js"

import "./notificationMessage.vue?vue&type=style&index=0&id=4b13cc00&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b13cc00"]])

export default __exports__